import { render } from "./WhatHappening.vue?vue&type=template&id=81aa6ef8"
import script from "./WhatHappening.vue?vue&type=script&lang=js"
export * from "./WhatHappening.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__